// extracted by mini-css-extract-plugin
module.exports =  {"root":"HlcDb0FtbI8HNddhsiqK","controls":"CJX6_wSgkaFgOwOP4sdd","segmentedControlWrapper":"Dg7gncTN2mAsd0XFdJFa","donationsGrid":"jaefxEwOAQaPB1P497eo"};